import { Injectable, Injector } from '@angular/core'
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { AuthenticationService } from './authentication.service'
import { catchError } from 'rxjs/operators'
import { LoggingService } from '@services/logging.service'

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService, private injector: Injector) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // get the logger
    const logger = this.injector.get(LoggingService)

    // add authorization header with basic auth credentials if available
    const currentUser = this.authenticationService.currentUserValue
    if (currentUser && currentUser.authdata) {
      request = request.clone({
        setHeaders: {
          Authorization: `Basic ${currentUser.authdata}`,
        },
      })
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // create message
        const message =
          'Error from BasicAuthInterceptor: ' +
          error.status +
          ' - ' +
          error.statusText +
          ' --> ' +
          error.message

        logger.logError(message)
        return throwError(error)
      })
    )
  }
}
